import PhoneNumberInput from "components/form-components/phone-number-input";
import { PhoneFormFieldProps } from "../types";
import { memo, useState, useEffect, useMemo } from "react";
import debounce from "lodash/debounce";

const PhoneFormField = memo(({ name, label, disabled = false, required, props }: PhoneFormFieldProps) => {
  const { onChange, value, ...textFieldProps } = props;

  const [localValue, setLocalValue] = useState(value);

  // Debounced function to call the parent's onChange handler
  const debouncedOnChange = useMemo(
    () =>
      debounce((event) => {
        onChange(event);
      }, 300),
    [onChange],
  );

  const handleChange = (e: any) => {
    const newValue = e.target.value;
    setLocalValue(newValue); // Update local state immediately
    debouncedOnChange(e); // Trigger the parent's onChange after debounce
  };

  // Sync local state with the parent value when the parent changes
  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value);
    }
  }, [value]);

  return (
    <PhoneNumberInput
      {...textFieldProps}
      fullWidth
      required={required}
      type={"tel"}
      value={localValue}
      onChange={handleChange}
      id={name}
      label={label}
      name={name}
      onBlur={(event: any) => props?.onBlur && props?.onBlur(event)}
      disabled={disabled}
    />
  );
});

export default PhoneFormField;
